(function(){
    'use strict';

    var $subNav = $('.smp-subnav');

    if($subNav.length){

        $subNav.find('.smp-subnav__title button').each(function(){

            var $cur = $(this),
                $parentContainer = $cur.parent(),
                $parentLI = $cur.closest('li');

                $(this).click(function(){

                    if(!$parentContainer.hasClass('active')){
                        $parentLI.addClass('active');
                        $parentContainer.addClass('active');
                        $parentContainer.next('.smp-subnav__dropdown-wrapper').addClass('active');
                    }else {
                        $parentLI.removeClass('active');
                        $parentContainer.removeClass('active');
                        $parentContainer.next('.smp-subnav__dropdown-wrapper').removeClass('active');
                    }

                    return false;

                });

        });




        // Set up active classes
        // Data attribute lineage set by ESI args
        try {

            var lineage = $subNav.data('lineage');

            if (lineage.length) {

                lineage.forEach(function(asset_id) {


                    var $active_menu_item = $subNav.find('[data-id=' + asset_id + ']');

                    $active_menu_item.addClass("active");

                    $active_menu_item.children('.smp-subnav__title, .smp-subnav__dropdown-wrapper').addClass("active");

                });

            }


        } catch (error) {

        }

    }

}());
